import React, { useState } from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";
import { SetterOrUpdater } from "recoil";

const TableFilters = (props: {
  default?: string;
  filterText: SetterOrUpdater<string>;
  moduleDetails: string;
  textInputName: string;
  columnDetails: string;
  disabledButton: boolean;
  disabledTextBox: boolean;
}) => {
  const {
    filterText,
    textInputName,
    columnDetails,
    disabledButton,
    disabledTextBox,
  } = props;

  const [inputValue, setInputValue] = useState(
    props.default ? props.default : ""
  );

  const FilterData = () => {
    filterText(inputValue);
  };

  return (
    <div className="">
      <div className="grid grid-cols-12 space-x-2">
        <div className="col-span-3">
          <TextInput
            name={textInputName}
            placeholder={columnDetails}
            value={inputValue}
            disabled={disabledTextBox ? true : false}
            onChange={(e) => {
              setInputValue(e.target.value);
              e.target.value === "" && filterText("");
            }}
          />
        </div>
        <div className="flex flex-auto space-x-2">
          <SearchButton
            buttonValue="Search"
            className={
              inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
            }
            disabled={inputValue === "" || disabledButton ? true : false}
            onClick={() => {
              FilterData();
            }}
          />
          <div>
            <RefreshButton
              className={
                inputValue === "" || disabledButton
                  ? "opacity-50"
                  : "opacity-100"
              }
              disabled={inputValue === "" || disabledButton ? true : false}
              onClick={() => {
                filterText("");
                setInputValue("");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
